import { supabase } from './supabase';
import type { Database } from './database.types';

type PickupCode = Database['public']['Tables']['pickup_codes']['Row'];

/** Returns the repair's active pickup code, or null if it has none. */
export const getActivePickupCode = (codes?: PickupCode[] | null): string | null =>
  codes?.find((c) => c.is_active)?.code ?? null;

/**
 * Hand a ready repair over to the customer: when SMS is enabled the entered
 * code must match the active pickup code; then the repair is marked 'picked'.
 * Returns an error message (Uzbek, user-facing) or null on success.
 */
export async function confirmPickup(params: {
  repairId: string;
  codes?: PickupCode[] | null;
  enteredCode: string;
  requireCode: boolean;
}): Promise<string | null> {
  const { repairId, codes, enteredCode, requireCode } = params;

  if (requireCode) {
    const expected = getActivePickupCode(codes);
    if (!expected) return "Bu ta'mirlash uchun olib ketish kodi topilmadi";
    if (enteredCode.trim() !== expected) return "Noto'g'ri kod kiritildi";
  }

  const { error } = await supabase
    .from('repairs')
    .update({ status: 'picked' })
    .eq('id', repairId);

  if (error) {
    console.error('Error marking repair as picked:', error);
    return "Saqlashda xatolik yuz berdi";
  }
  return null;
}
